import _ from 'underscore';
import { useCallback, useState } from 'react';
import { v4 as uuidV4 } from 'uuid';

export interface IServerContext {
  CurrentCustomer: {
    Id: number,
  },
  CurrentAccount: {
    Id: number,
  },
}

export interface IAssetEventProps {
  shouldLog: boolean;
  serverContext: IServerContext;
  channel: string;
  feature: string;
  scenario: string;
  campaignId?: number;
  assetGroupId?: number;
  withCredentials?: boolean;
  logTrace?: (message: string) => void;
}

export interface IPostData {
  EventName: string;
  EventValue?: Record<string, unknown>;
}

export function usePostAssetEvent({
  shouldLog,
  serverContext,
  channel,
  feature,
  scenario,
  campaignId,
  assetGroupId,
  logTrace = _.noop,
}: IAssetEventProps) {
  const accountId = serverContext.CurrentAccount?.Id;
  const customerId = serverContext.CurrentCustomer?.Id;

  const [initStatus] = useState({
    Channel: channel,
    Feature: feature,
    Scenario: scenario,
    AccountId: accountId,
    UniqueId: uuidV4(),
    CampaignId: campaignId,
    AssetGroupId: assetGroupId,
  });

  const postEvent = useCallback(({ EventName, EventValue }: IPostData) => {
    if (shouldLog && accountId && customerId) {
      const data = {
        UniqueId: initStatus.UniqueId,
        EventName,
        EventValue: JSON.stringify({
          ...initStatus,
          ...EventValue,
          TimeStamp: new Date().toISOString(),
        }),
      };

      logTrace(`[PostAssetEventLog]: UniqueId: ${data.UniqueId}, EventName: ${EventName}, EventValue: ${data.EventValue}`);
    }
  }, [accountId, customerId, initStatus, logTrace, shouldLog]);

  return postEvent;
}
